export const en_careers_form = {
  "form-title": "Apply for available position",
  "form-position": "Job title *",
  "form-position-1": "Aquaculture Engineer",
  "form-position-2": "Hatchery Technician",
  "form-position-3": "Flupsy Technician",
  "form-first-name": "First name *",
  "form-last-name": "Last name *",
  "form-email": "E-mail *",
  "form-phone-number": "Phone number *",
  "form-comment": "Comment",
  "form-resume-label": "Attach a resume",
  "form-resume-upload-btn": "&#10149; Choose file &lt; 5 MB, .pdf",
  "form-agreement": "I give my consent to the processing of personal data in accordance with ",
  "form-agreement-terms": "terms *",
  "form-submit": "submit",
  "form-valid-fields-error": "Fill in the required fields",
  "form-valid-resume-ext-error": "Wrong file resolution",
  "form-valid-resume-size-error": "File size must be less than 5MB",
  "form-valid-resume-load-error": "File not loaded try again",
  "form-successfully-send": "Successfully sent",
  "form-error-send": "Failed to send form, try again",
}

export const it_careers_form = {
  "form-title": "Candidati per una posizione",
  "form-position": "Titolo di lavoro *",
  "form-position-1": "Acquacoltura Ingegnere",
  "form-position-2": "Tecnico Di Schiuditoio",
  "form-position-3": "Tecnico Di Flupsy",
  "form-first-name": "Nome *",
  "form-last-name": "Cognome *",
  "form-email": "E-mail *",
  "form-phone-number": "Numero di telefono *",
  "form-comment": "Commento",
  "form-resume-label": "Allegare un curriculum",
  "form-resume-upload-btn": "&#10149; Scegliere file &lt; 5 MB, .pdf",
  "form-agreement": "Do il mio consenso al trattamento dei dati personali in conformità con ",
  "form-agreement-terms": "termini *",
  "form-submit": "invia",
  "form-valid-fields-error": "Compila i campi richiesti",
  "form-valid-resume-ext-error": "Risoluzione dei file errata",
  "form-valid-resume-size-error": "La dimensione del file deve essere inferiore a 5MB",
  "form-valid-resume-load-error": "File non caricato riprova",
  "form-successfully-send": "Spedito con successo",
  "form-error-send": "Invio del modulo non riuscito, riprovare",
}